import { WorldPoint3 } from '@strava/mre';

import type { LatLngElevation } from '../types';

export const getWorldPoint3ArrayFromLatLngElevationArray: (
  points: LatLngElevation[]
) => WorldPoint3[] = (points) => {
  return points.map(([latitude, longitude, elevation]) => ({
    latitude,
    longitude,
    elevation
  }));
};
